import { createRouter, createWebHistory } from 'vue-router';
import LoginPage from '../views/LoginPage.vue'; // Importamos la página de login

// Definir las rutas de la aplicación
const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginPage, // Componente de la página de login
    meta: { requiresAuth: false } // No requiere autenticación para acceder
  },
  {
    path: '/main',
    name: 'Main',
    component: () => import('../views/MainPage.vue'), // Componente de la página principal
    meta: { requiresAuth: true } // Requiere autenticación
  },
  {
    path: '/camiones',
    name: 'Camiones',
    component: () => import('../views/CamionesPage.vue'), // Componente de la página principal
    meta: { requiresAuth: true } // Requiere autenticación
  },
  {
    path: '/conductores',
    name: 'Conductores',
    component: () => import('../views/ConductoresPage.vue'), // Componente de la página principal
    meta: { requiresAuth: true } // Requiere autenticación
  },
  {
    path: '/cargue_transporte',
    name: 'CargueTransporte',
    component: () => import('../views/CyTPage.vue'), // Componente de la página principal
    meta: { requiresAuth: true } // Requiere autenticación
  },
  {
    path: '/autorizaciones',
    name: 'Autorizaciones',
    component: () => import('../views/AutorizacionesPage.vue'), // Componente de la página principal
    meta: { requiresAuth: true } // Requiere autenticación
  },
  {
    path: '/inventario_plantas',
    name: 'InventarioPlantas',
    component: () => import('../views/InventarioPlantasPage.vue'), // Componente de la página principal
    meta: { requiresAuth: true } // Requiere autenticación
  },
  {
    path: '/concreto',
    name: 'Concreto',
    component: () => import('../views/ConcretoPage.vue'), // Componente de la página principal
    meta: { requiresAuth: true } // Requiere autenticación
  },
  {
    path: '/arriendos',
    name: 'Arriendos',
    component: () => import('../views/ArriendoPage.vue'), // Componente de la página principal
    meta: { requiresAuth: true } // Requiere autenticación
  },
  {
    path: '/gastos_generales',
    name: 'GastosGenerales',
    component: () => import('../views/GastosPage.vue'), // Componente de la página principal
    meta: { requiresAuth: true } // Requiere autenticación
  },
  {
    path: '/cuentas_x_pagar',
    name: 'CuentasXPagar',
    component: () => import('../views/CuentasPage.vue'), // Componente de la página principal
    meta: { requiresAuth: true } // Requiere autenticación
  },
  {
    path: '/bitacora',
    name: 'Bitacora',
    component: () => import('../views/BitacoraPage.vue'), // Componente de la página principal
    meta: { requiresAuth: true } // Requiere autenticación
  },
  // Otras rutas de la aplicación
];

// Crear el router con el historial de navegación
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Guardar el estado de autenticación antes de acceder a una ruta
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('user_acces');
  
  // Si la ruta requiere autenticación y el usuario no está autenticado
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/'); // Redirigir a la página de login
  } else {
    next(); // Permitir la navegación
  }
});

export default router;
